import { render, staticRenderFns } from "./incident.vue?vue&type=template&id=817dabc0&scoped=true"
import script from "./incident.vue?vue&type=script&lang=js"
export * from "./incident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817dabc0",
  null
  
)

export default component.exports